
<template>
<div class="row clearfix">
    <div class="col-lg-4 cool-md-6 col-sm-12" v-for="(plan, index) in planList" :key="index">
      <div class="card">
        <ul class="pricing body" :class="{'active' : getPlanSelected(plan.planName) }">
          <li><big>{{plan.planName}}</big></li>
          <div v-html="getPlanInsideData(plan.countQuery, plan.accessQuery, plan.commonTagQuery)"></div>
<!--          <li>{{ getPlanInsideData(plan.countQuery, plan.accessQuery, plan.commonTagQuery) }}</li>-->
<!--          <li>유저 1</li>-->
<!--          <li>리드 1,000</li>-->
<!--          <li>15분 동기화</li>-->
<!--          <li>1,000 Works/ 5 Flow</li>-->
          <!-- <li>HTML5 &amp; CSS3</li> -->
          <!-- <li>Styled elements</li> -->
          <li>
            <h3>{{ setPrice(plan.planPrice) }}원</h3>
            <span>매달</span>
          </li>

          <li v-if="$route.path.includes('profile')"><button class="btn btn-primary btn-simple" @click="signupPayment(plan.planPrice)">신청</button></li>
          <li v-if="!$route.path.includes('profile')"><button class="btn btn-primary btn-simple" @click="toLogin">신청</button></li>
        </ul>
      </div>
    </div>
<!--    <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--      <div class="card">-->
<!--        <ul class="pricing body"  :class="{'active' : planType == 'special' }">-->
<!--          <li><big>스페셜</big></li>-->
<!--          <li>유저 1</li>-->
<!--          <li>리드 1,500</li>-->
<!--          <li>15분 동기화</li>-->
<!--          <li>1,500 Works/ 10 Flow</li>-->
<!--          &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--          &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--          <li>-->
<!--            <h3>310,000원</h3>-->
<!--            <span>매달</span>-->
<!--          </li>-->
<!--          <li><button class="btn btn-primary" @click="signupPayment(310000)">신청</button></li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--      <div class="card">-->
<!--        <ul class="pricing body" :class="{'active' : planType == 'premium' }">-->
<!--          <li><big>프리미엄</big></li>-->
<!--          <li>유저 1</li>-->
<!--          <li>리드 6,000</li>-->
<!--          <li>15분 동기화</li>-->
<!--          <li>6,000 Works/ 20 Flow</li>-->
<!--          &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--          &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--          <li>-->
<!--            <h3>500,000원</h3>-->
<!--            <span>매달</span>-->
<!--          </li>-->
<!--          <li><button class="btn btn-primary btn-simple" @click="signupPayment(500000)">신청</button></li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--      <div class="card">-->
<!--        <ul class="pricing body" :class="{'active' : planType == 'campaign basic' }">-->
<!--          <li><big>캠페인 베이직</big></li>-->
<!--          <li>유저 1</li>-->
<!--          <li>리드 10,000</li>-->
<!--          <li>1분 동기화</li>-->
<!--          <li>10,000 Works/ 무제한 Flow</li>-->
<!--          &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--          &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--          <li>-->
<!--            <h3>1,980,000원</h3>-->
<!--            <span>매달</span>-->
<!--          </li>-->
<!--          <li><button class="btn btn-primary btn-simple" @click="signupPayment(1980000)">신청</button></li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
<!--  <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--    <div class="card">-->
<!--      <ul class="pricing body" :class="{'active' : planType == 'campaign special' }">-->
<!--        <li><big>캠페인 스페셜</big></li>-->
<!--        <li>유저 1</li>-->
<!--        <li>리드 25,000</li>-->
<!--        <li>1분 동기화</li>-->
<!--        <li>25,000 Works/ 무제한 Flow</li>-->
<!--        &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--        &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--        <li>-->
<!--          <h3>2,980,000원</h3>-->
<!--          <span>매달</span>-->
<!--        </li>-->
<!--        <li><button class="btn btn-primary btn-simple" @click="signupPayment(2980000)">신청</button></li>-->
<!--      </ul>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="col-lg-4 cool-md-6 col-sm-12">-->
<!--    <div class="card">-->
<!--      <ul class="pricing body" :class="{'active' : planType == 'campaign premium' }">-->
<!--        <li><big>캠페인 프리미엄</big></li>-->
<!--        <li>유저 1</li>-->
<!--        <li>리드 50,000</li>-->
<!--        <li>1분 동기화</li>-->
<!--        <li>50,000 Works/ 무제한 Flow</li>-->
<!--        &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--        &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--        <li>-->
<!--          <h3>3,980,000원</h3>-->
<!--          <span>매달</span>-->
<!--        </li>-->
<!--        <li><button class="btn btn-primary btn-simple" @click="signupPayment(3980000)">신청</button></li>-->
<!--      </ul>-->
<!--    </div>-->
<!--  </div>-->
<!--    <div class="col-lg-3 cool-md-6 col-sm-12">-->
<!--      <div class="card">-->
<!--        <ul class="pricing body">-->
<!--          <li><big>VIP</big></li>-->
<!--          <li>워크 무제한</li>-->
<!--          <li>테스크 무제한</li>-->
<!--          &lt;!&ndash; <li>HTML5 &amp; CSS3</li> &ndash;&gt;-->
<!--          &lt;!&ndash; <li>Styled elements</li> &ndash;&gt;-->
<!--          <li>-->
<!--            <h3>200,000</h3>-->
<!--            <span>매달</span>-->
<!--          </li>-->
<!--          <li><button class="btn btn-primary btn-simple">신청</button></li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  props : ['planType'],
  name: "PlanPage",
  data(){
    return{
      planList : null,
      planInside : null,
    }
  },
  methods : {
    getPlanSelected(planName){
      console.log(planName, this.planType)

      if(this.planType != null){
        if(this.planType.indexOf("플랜") > 0 && this.planType.replace(' 플랜', '') == planName){
          return true;

        } else {
          return false;
        }
      }

    },
    toLogin(){
      alert("로그인 후 이용해주세요.")
      this.$router.push({name : 'LoginPage'})
    },
    getPlanInsideData(count, access, tag){
      console.log(count)
      console.log(access)
      console.log(tag)

      var tagSplit = tag.split(",");
      var countSplit = count.split(",");
      // var accessSplit = access.split(",");

      var totalPlan = "<li>유저 {userCount}</li><li>리드 {leadCount}</li><li>{syncCount}분 동기화</li><li>{workCount} Works/ {flowCount} Flow</li>"

      for(var i = 0; i < tagSplit.length; i++){
        console.log(tagSplit[i])
        console.log(countSplit[i])

          var num = countSplit[i];

          if(countSplit[i] == '-1'){
            num = '무제한';
          } else {
            num = this.setPrice(countSplit[i])
          }

        if(tagSplit[i] == 'PLAN_AUTO'){

          totalPlan = totalPlan.replace('{workCount}', num)

        } else if(tagSplit[i] == 'PLAN_AUTO2'){
          totalPlan = totalPlan.replace('{flowCount}', num)

        } else if(tagSplit[i] == 'BOUCHER'){
          totalPlan = totalPlan.replace('{userCount}', num)

        } else if(tagSplit[i] == 'TRACKING'){
          totalPlan = totalPlan.replace('{syncCount}', num)

        } else if(tagSplit[i] == 'LEAD'){
          totalPlan = totalPlan.replace('{leadCount}', num)

        }
      }

      return totalPlan;
    },
    setPrice(p) {
      var price = p.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return price;
    },
    signupPayment(money){
      console.log("플랜")
      this.$store.dispatch("getPayModal", {
        state : true,
        price : money
      });
    }
  },
  created() {
    console.log("PlanPage.created");

    var param = {}

    this.api.getPlanList(param)
    .then((res)=>{
      console.log(res)

      if(this.utils.preApiHandle(res)) {
        console.log("profile edit res : ", res)
      }

      this.planList = res.planList;

    })

  },
  mounted() {
    console.log("PlanPage.mounted");
  },
  beforeDestroy() {
    console.log("PlanPage.beforeDestroy");
  }
}
</script>
